function onBedrockAccountCreate() {
  if (__DEV__) {
    console.log('Web.Zephr:event: onBedrockAccountCreate', e);
  }

  // Unmount all outcomes because they are remounted with a JWT token.
  // Account create automatically signs a user in and does so using a different code
  // path than typical sign in
  dispatchEvent(new CustomEvent('onzephrunmountalloutcomes'));
}

export default onBedrockAccountCreate;
